import * as React from 'react';
import { Tag } from '@cian/components';

import { IIdenticalOffersIdTag } from '../../../state/tags/definitions/identical_offers_id';
import { TagNew } from '../TagNew';
import { tagThemeSmall } from '../tag_theme';

export interface IIdenticalOffersIdTagItemProps {
  tag: IIdenticalOffersIdTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const IdenticalOffersIdTagItem = ({ tag, onDeleteClick, withNewTag }: IIdenticalOffersIdTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent tagStyles={tagThemeSmall} onDeleteClick={onDeleteClick}>
      Мультиобъявление №{tag.value}
    </TagComponent>
  );
};
